import { userActionTypes } from '../actions/types';

const initialState = {};

export function user(state = initialState, action) {
  switch (action.type) {
    case userActionTypes.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.GETALL_SUCCESS:
      return {
        ...state,
        items: action.users,
        loading: false,
      };
    case userActionTypes.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case userActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        updateState: 'updating',
        error: null,
      };
    case userActionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        updateState: 'updated',
      };
    case userActionTypes.UPDATE_FAILURE:
      return {
        ...state,
        updateState: 'failed',
        error: action.error,
      };
    case userActionTypes.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        deleting: true,
        deleted: false,
        items: state.items.map(user =>
          user.id === action.id ? { ...user, deleting: true } : user,
        ),
      };
    case userActionTypes.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        ...state,
        deleting: false,
        deleted: true,
        items: state.items.filter(user => user.id !== action.id),
      };
    case userActionTypes.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        deleting: false,
        deleted: false,
        items: state.items.map(user => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        }),
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_REQUEST:
      return {
        ...state,
        changingAvatarState: 'request',
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        changingAvatarState: 'success',
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_FAILURE:
      return {
        ...state,
        changingAvatarState: 'failure',
      };
    default:
      return state;
  }
}
